/**
 * Override config when VPAID is enabled
 * - confirm skip should be disabled
 * - TODO disable other features
 */
export function mutateConfigForVpaid(config: FormatConfig): FormatConfig {
  return {
    ...config,
    confirmSkip: {
      ...config.confirmSkip,
      enabled: false
    }
  };
}
